import { icons, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import newExcel from "../../../assets/images/newExcel.svg";
export var REPORT_FILTERS = [
    {
        label: "Limpiar Filtros",
        type: "cleanButton",
        variantButtons: variants.text,
        visible: true,
    },
    {
        disabled: false,
        label: "Exportar",
        listButtonDropdown: [
            {
                icons: icons.DownloadForOffline,
                id: "1",
                img: newExcel,
                name: "Descargar Excel",
            },
        ],
        showImage: true,
        type: "exportButton",
        variantButtons: variants.text,
        visible: true,
    },
    {
        id: "dateRange",
        label: "Rango de fechas",
        type: "dateRange",
    },
];
export var INITIAL_PAGE = 1;
export var INITIAL_PAGE_SIZE = 5000;
